import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
export const StyleLink = styled(Link)`
  font-size: 14px;
  color: ${(props: any) => props.theme.colors.secondary};
  font-weight: 400;
`
